import {
  generateGetAction,
  generatePutAction,
  generateDeleteAction,
  generateAction,
} from '@services/ActionDispatcher';

import {
  getDentistListAction,
  getMyClinicListAction,
  getAffiliatedDentistListAction,
  deleteAffiliatedClinicAction,
  declineDentistInviteAction,
  acceptDentistInviteAction,
  getReferralFilterDentistListAction,
  getReferralFilterListAction,

  updateMyClinicInvitesCountAction,
} from './DentistActionConfig';

const updateMyClinicInvitesCountDispatch = (
  data: any) => generateAction(updateMyClinicInvitesCountAction, data);

const getDentistListRequest = (params: any) => generateGetAction(
  // action name
  getDentistListAction,
  // url
  'dentists',
  {
    queryParams: params,
  },
);

const getMyClinicListRequest = (params: any) => generateGetAction(
  // action name
  getMyClinicListAction,
  // url
  'dentist/clinics/affiliated',
  {
    queryParams: params,
  },
);

const getAffiliatedDentistListRequest = (params: any) => generateGetAction(
  // action name
  getAffiliatedDentistListAction,
  // url
  'affiliated-dentists',
  {
    queryParams: params,
  },
);

const deleteAffiliatedClinicRequest = (id: any) => generateDeleteAction(
  // action name
  deleteAffiliatedClinicAction,
  // url
  `dentist/clinics/${id}/affiliated`,
);

const declineDentistInviteRequest = (id: any, data: any) => generatePutAction(
  // action name
  declineDentistInviteAction,
  // url
  `dentist/clinics/invites/${id}/decline`,
  data,
);

const acceptDentistInviteRequest = (id: any, data: any) => generatePutAction(
  // action name
  acceptDentistInviteAction,
  // url
  `dentist/clinics/invites/${id}/accept`,
  data,
);

const getReferralFilterDentistListRequest = (params: any) => generateGetAction(
  // action name
  getReferralFilterDentistListAction,
  // url
  'dentist/referrals/dropdown/dentist-list',
  {
    queryParams: params,
  },
  params,
);

const getReferralFilterListRequest = (params: any) => generateGetAction(
  // action name
  getReferralFilterListAction,
  // url
  'dentist/referrals/dropdown/filter-list',
  {
    queryParams: params,
  },
  params,
);

export {
  // normal dispatch
  updateMyClinicInvitesCountDispatch,

  // async (request) dispatch
  getDentistListRequest,
  getMyClinicListRequest,
  getAffiliatedDentistListRequest,
  deleteAffiliatedClinicRequest,
  declineDentistInviteRequest,
  acceptDentistInviteRequest,
  getReferralFilterDentistListRequest,
  getReferralFilterListRequest,
};
